import { api } from "./api";

export const modalityList = async (params: {
  search?: string;
}): Promise<any> => {
  const { data } = await api.get("store/fights", { params });
  return data;
};

export const modalityCreate = async (body: {
  name: string;
  description?: string;
}): Promise<any> => {
  const { data } = await api.post("store/fights", body);
  return data;
};

export const modalityUpdate = async (body: {
  id: string | number;
  name: string;
  description?: string;
}): Promise<any> => {
  const { data } = await api.put("store/fights/update", body);
  return data;
};

export const modalityDelete = async (body: {
  id: string | number;
}): Promise<any> => {
  const { data } = await api.put("store/fights/delete", body);
  return data;
};
